import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataGateResponse } from '../models/datagate/datagate.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataGateService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getDataGateData(tokenIdentifier: string): Observable<DataGateResponse> {
    return this.http.get<DataGateResponse>(`${this.apiUrl}/DataGate/${tokenIdentifier}`);
  }

  postDataGateData(url: string, data: any): Observable<any> {
    return this.http.post<any>(url, data);
  }
}
